import { Component, OnChanges } from '@angular/core';
import { NavController, MenuController, Platform, ActionSheetController, Events, ModalController } from 'ionic-angular';
import { ServerService } from '../../services/server-service';
import { getStoreRateLabel as resolveStoreRateLabel } from '../../services/store-rate';
import {
  isQuestionnaireSubmitted,
  openQuestionnaireModal,
} from '../../components/app-questionnaire/open-questionnaire-modal';

import {
  ChartReadyEvent, ChartErrorEvent, ChartSelectEvent,
  ChartMouseOverEvent, ChartMouseOutEvent
} from 'ng2-google-charts';
import { GoogleChartInterface } from 'ng2-google-charts/google-charts-interfaces';

import { LocalNotifications } from '@ionic-native/local-notifications';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  matnasName: any = '';
  mercazImage: any = '';
  adminFullName: any = '';
  greetingText: string = 'שלום';
  devNews: any = [];
  showDevNews: boolean = false;
  devNewsLoading: boolean = false;
  visitsLoading: boolean = false;


  notificationsLoading: boolean = false;
  matnasnetNotificaitons: any = [];
  showMatnasnetNotificaitions: boolean = false;

  eventsScannedata: any = [];

  visitsData: GoogleChartInterface;
  visitsDataType: any = 'מתחילת שבוע';
  visitsCount = 0;
  chartReady: boolean = false;
  showRateStore: boolean = false;
  storeRateLabel: string = 'App Store';
  showQuestionnaire: boolean = true;
  private readonly RATE_MODAL_TEST_MODE: boolean = false;
  menuActions: Array<{ title: string, subtitle: string, component: any, icon: string, color: string }> = [
    { title: 'אירועים', subtitle: 'ניהול וצפייה', component: 'EventsPage', icon: 'calendar-outline', color: 'secondary' },
    { title: 'סריקה', subtitle: 'סריקת כרטיסים', component: 'ScanticketsPage', icon: 'qr-scanner-outline', color: 'accent' },
    { title: 'סריקת כרטיס/יות בפריטים', subtitle: 'סריקת פריטים', component: 'ScanproductPage', icon: 'qr-scanner-outline', color: 'success' },
    { title: 'פניות', subtitle: 'הודעות ופניות', component: 'MessagesPage', icon: 'mail-outline', color: 'info' },
    { title: 'קריאת שירות', subtitle: 'פתיחת פנייה', component: 'supportMenu', icon: 'alert-outline', color: 'warning' },
    { title: 'הגדרות', subtitle: 'העדפות מערכת', component: 'SettingsPage', icon: 'settings-outline', color: 'purple' },
  ];


  constructor(public navCtrl: NavController,
    public menuCtrl: MenuController,
    private api: ServerService,
    public platform: Platform,
    public actionSheetCtrl: ActionSheetController,
    private localNotifications: LocalNotifications,
    private events: Events,
    public modalCtrl: ModalController) {
    this.matnasName = localStorage.getItem('mercazName');
    this.greetingText = this.getGreetingText();
    // this.menuCtrl.enable(false);
    // this.menuCtrl.swipeEnable(false);



  }

  private getGreetingText(date: Date = new Date()): string {
    const hour = date.getHours();
    if (hour >= 5 && hour < 12) {
      return 'בוקר טוב';
    }
    if (hour >= 12 && hour < 17) {
      return 'צהריים טובים';
    }
    if (hour >= 17 && hour < 22) {
      return 'ערב טוב';
    }
    return 'לילה טוב';
  }

  onMercazImgError(ev: Event): void {
    const imgEl: any = ev && (ev.target as any);
    if (!imgEl) {
      return;
    }

    imgEl.onerror = null;
    imgEl.src = 'assets/imgs/atarixLogo.png';
  }

  loguserFunction() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    console.log("object:", object);

    this.api.sendPostParams('/log/logUser.php', object).then((data) => {
      if (data['sucsses']) {
        this.mercazImage = data['mercazImage'];
        this.adminFullName = data['personalFullName'];
      }


    }, (err => {
      console.log("error2:", JSON.stringify(err));

    }));
  }



  private isUserBlockedResponse(data: any): boolean {
    return data && data['success'] === false && data['error'] === 'User is blocked';
  }

  getDevNews() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    console.log("object:", object);
    this.devNewsLoading = true;
    this.api.sendPostParams('/news/getDevNews.php', object).then((data) => {
      this.devNewsLoading = false;
      console.log("dev news:", data);
      if (this.isUserBlockedResponse(data)) {
        this.events.publish('user:blocked');
        return;
      }
      if (data['sucsses']) {
        this.devNews = data['devNews'];
        if (this.devNews.length > 0) {
          this.showDevNews = true;
        }
      }
      // this.getVisits('today');
      this.getNotifications();
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.devNewsLoading = false;
      // this.getVisits('today');
      this.getNotifications();

    }));
  }


  getNotifications() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    console.log("object:", object);
    this.notificationsLoading = true;
    this.api.sendPostParams('/news/getNotifications.php', object).then((data) => {
      this.notificationsLoading = false;

      // console.log("notitifcations:", data);
      if (data['sucsses']) {
        this.matnasnetNotificaitons = data['matnasnetNotificaitons'];


        if (this.matnasnetNotificaitons.length > 0) {
          this.showMatnasnetNotificaitions = true;
        }
      }
      this.getEventsScannedCount('week');
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.notificationsLoading = false;
      this.getEventsScannedCount('week');
    }));
  }






  getEventsScannedCount(getVisitsBy) {
    this.chartReady = false;
    this.visitsLoading = true;
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
      "getVisitsBy": getVisitsBy,
    };
    console.log("object:", object);
    this.api.sendPostParams('/charts/getEventScannedCount.php', object).then((data) => {

      this.visitsLoading = false;
      if (data['sucsses']) {
        this.eventsScannedata = data['eventsScannedata'];
        this.drawVisitsCount(this.eventsScannedata);
      }

    }, (err => {
      this.visitsLoading = false;
      console.log("error2:", JSON.stringify(err));

    }));
  }


  openDevNews(row) {
    this.navCtrl.push('DevnewsPage', {
      item: row,
    });
  }

  goSupport() {
    this.navCtrl.push('SupportrequestPage');
  }

  openMenuAction(action) {
    if (action.component == 'supportMenu') {
      this.navCtrl.push('SupportrequestPage');
      return;
    }

    if (action.component == 'HomePage') {
      this.navCtrl.setRoot(HomePage);
      return;
    }

    this.navCtrl.push(action.component);
  }

  drawVisitsCount(eventsScannedata) {
    console.log("eventsScannedata:", eventsScannedata);


    if (eventsScannedata && typeof eventsScannedata == "object") {
      let firstRow = ['שם האירוע', 'כמות סריקת אירועים', { role: 'annotation' }];
      let payload: any = [];
      payload.push(firstRow);
      eventsScannedata.forEach(element => {
        let pushRow: any = [element['eventname'], element['ticketsScannedCount'], element['ticketsScannedCount']];
        payload.push(pushRow)
      });

      console.log("payload:", payload);

      this.visitsData = {
        chartType: 'BarChart',
        dataTable: payload,

        options: {
          "displayExactValues": true,
          'title': "", vAxis: { title: '' }, hAxis: { title: '' },
          legend: { position: 'top', alignment: 'end' },
          height: this.platform.height() * 0.3,
          width: this.platform.width()
        },
        // chartArea: { width: '90%', height: '90%' },
      };
    }

  }


  onPieReady(event: ChartReadyEvent) {
    console.log("Chart ready:", event);
    this.chartReady = true;
  }

  chartError(error) {
    console.log("chart error:", error);
  }


  filterOptions() {

    let actionSheet = this.actionSheetCtrl.create({
      title: 'מיון',
      buttons: [
        // {
        //   text: 'היום',
        //   handler: () => {
        //     console.log('Archive clicked');
        //     this.visitsDataType = 'היום';
        //     this.getEventsScannedCount('today');
        //   }
        // },
        {
          text: 'מתחילת השבוע',
          handler: () => {
            console.log('Archive clicked');
            this.visitsDataType = 'מתחילת השבוע';
            this.getEventsScannedCount('week');
          }
        },
        {
          text: 'מתחילת החודש',
          handler: () => {
            console.log('Archive clicked');
            this.visitsDataType = 'מתחילת החודש';
            this.getEventsScannedCount('month');
          }
        },

      ]
    });

    actionSheet.present();
  }



  ionViewDidLoad() {
    this.getDevNews();
    this.loguserFunction();

    this.showQuestionnaire = !isQuestionnaireSubmitted();

    this.showRateStore = this.isNativeStorePlatform();
    if (this.showRateStore) {
      this.storeRateLabel = this.getStoreRateLabel();
      this.maybeShowRateModal();
    }
  }

  private isNativeStorePlatform(): boolean {
    return this.platform.is('ios') || this.platform.is('android');
  }

  private getStoreRateLabel(): string {
    return resolveStoreRateLabel(this.platform);
  }

  private maybeShowRateModal() {
    if (!this.isNativeStorePlatform()) {
      return;
    }
    if (!this.RATE_MODAL_TEST_MODE) {
      try {
        if (localStorage.getItem('rateModalShownV1') === '1') {
          return;
        }

        const raw = localStorage.getItem('rateModalAppLaunches');
        const launches = raw ? parseInt(raw, 10) : 0;
        if (isNaN(launches) || launches < 2) {
          return;
        }
      } catch (e) {
        return;
      }
    }

    setTimeout(() => {
      this.openRateAppModal();
    }, this.RATE_MODAL_TEST_MODE ? 800 : 2500);
  }

  openQuestionnaire() {
    openQuestionnaireModal(this.modalCtrl).then((data: any) => {
      if (data && data.submitted) {
        this.showQuestionnaire = false;
      }
    });
  }

  openRateAppModal() {
    const modal = this.modalCtrl.create('RateappmodalPage', {}, {
      cssClass: 'rate-app-modal',
      enableBackdropDismiss: true,
    });
    modal.onDidDismiss((data: any) => {
      if (this.RATE_MODAL_TEST_MODE) {
        return;
      }
      if (data && (data.rated || data.later || data.closed)) {
        try { localStorage.setItem('rateModalShownV1', '1'); } catch (e) { /* noop */ }
      }
    });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts